/* CuisineHub — /cuisine: every cuisine that has public recipes. */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import PageMeta from "@/components/PageMeta";

export default function CuisineHub() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/directory/cuisine-pages").then((r) => setRows(r.data || [])).catch(() => setRows([])); }, []);
  return (
    <div className="max-w-7xl mx-auto px-6 md:px-10 py-20">
      <PageMeta title="Recipes by cuisine: family cooking from around the world"
                description="Browse family recipes by cuisine on Recipe Filer: British, Italian, Indian, Irish and more, all from real family kitchens." />
      <Link to="/directory" className="text-sm font-bold text-rf-orange hover:underline">← All recipes</Link>
      <p className="overline mt-4 mb-3">Cuisines</p>
      <h1 className="font-display text-5xl md:text-7xl font-black text-rf-ink mb-6 leading-[0.95]" data-testid="cuisine-hub-heading">Recipes by cuisine</h1>
      <p className="text-rf-ink-soft text-lg mb-10 max-w-2xl">Family cooking from around the world, grouped by where it comes from.</p>
      {rows === null ? <p className="text-rf-ink-soft">Loading…</p>
        : rows.length === 0 ? <p className="text-rf-ink-soft">No cuisines yet.</p>
        : <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5" data-testid="cuisine-hub-list">
            {rows.map((c) => (
              <Link key={c.slug} to={`/cuisine/${c.slug}`} data-testid={`cuisine-hub-${c.slug}`}
                    className="group relative rounded-2xl overflow-hidden aspect-[4/3] bg-rf-ink shadow-md">
                {c.hero_url && <img src={c.hero_url} alt={c.hero_alt || `${c.cuisine} family recipes`} loading="lazy" className="absolute inset-0 w-full h-full object-cover opacity-90 transition-transform duration-500 group-hover:scale-105" />}
                <div className="absolute inset-0 bg-gradient-to-t from-rf-ink/85 via-rf-ink/20 to-transparent" />
                <div className="absolute bottom-0 left-0 p-4">
                  <p className="font-display font-black text-xl text-rf-cream leading-tight">{c.cuisine}</p>
                  <p className="text-xs font-semibold text-rf-cream/80">{c.count} recipe{c.count === 1 ? "" : "s"}</p>
                </div>
              </Link>
            ))}
          </div>}
    </div>
  );
}
